import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EditorFeature } from './editor.actions';
import { EditorState } from './reducer/editor.reducer';

export const selectEditorState = createFeatureSelector<EditorState>(EditorFeature);

export const selectColors = createSelector(selectEditorState, (state: EditorState) => state?.colors ?? []);

export const selectHasColors = createSelector(selectColors, (colors: string[]) => colors.length > 0);

